<div class="bg-stone-100 page customer_alignment" [dir]="textDirection" [lang]="language">
  <router-outlet></router-outlet>
</div>
<div kendoDialogContainer></div>
